module.exports = __webpack_public_path__ + "ipetbooking-landing/img/section5-image.73e89de3.png";